<template>
    <div>
        <div class="columns">
            <div class="column is-12">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Total open services</span>
                    </span>
                </h1>
            </div>
        </div>
        <o-field grouped group-multiline>
            <o-select v-if="!filters.viewAll && table.paginated" v-model="table.perPage">
                <option v-for="(opt, idx) in table.perPageOptions" :key="idx" :value="opt">{{opt}} per page</option>
                <option :value="items.length">View all</option>
            </o-select>
        </o-field>
        <o-table
            class="open-services-table is-responsive-desktop"
            v-if="isTableVisible"
            :bordered="table.bordered"
            :checkable="false"
            :columns="tableColumns"
            :data="items"
            :default-sort="table.defaultSort"
            :loading="loading"
            :mobile-cards="table.mobileCards"
            :narrowed="table.narrowed"
            :paginated="paginated"
            :per-page="table.perPage"
            :striped="table.striped"
        >
            <template>
                <template >
                    <o-table-column
                            v-for="(col, idx) in tableColumns" :key="idx + '_' + col.field"
                            v-if="col && !col._isVue"
                            #default="{ row }"
                            @click.native="openDetailsModal(row)"
                            :field="col.field"

                            :label="col.label"
                            :sortable="col.sortable"
                    >{{ row[col.field] }}</o-table-column>
                </template>
            </template>
            <template #footer>
                <th>Total</th>
                <th>
                    {{ totalsColumns.amountLabel }}
                </th>
                <th>
                    {{ totalsColumns.qty }}
                </th>
                <th>
                    {{ totalsColumns.daysAvg }}
                </th>
            </template>
          <template #empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isDetailsModalActive" has-modal-card width="100%">
            <services-per-user-modal :row="selectedRow" />
        </o-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ServicesPerUserModal from '../../../../components/modals/ServicesPerUserModal'
    import { getGroupingKey } from './utils'

    export default {
        components: {
            ServicesPerUserModal,
        },

        computed: {
            ...mapGetters([
                'appIsHydrated',
                'boroughNameById',
                'tableColumnsBySlug',
                'tableSettingsBySlug',
                'teamNameById',
                'teams',
                'workTypeNamesByIds',
            ]),

            paginated() {
                return !this.filters.viewAll && this.table.perPage !== this.items.length  && this.table.paginated
            },

            tableColumns() {
                return [
                { field: 'title', label: 'Open service', sortable: true },
                { customSort: this.customSort, field: 'amountLabel', label: 'Amount', sortable: true },
                { field: 'qty', label: 'Qty', sortable: true },
                { customSort: this.customSortDaysAvg, field: 'daysAvg', label: 'Avg Days', sortable: true },
            ]},

            totalsColumns() {
                const currency = this.$filters.currency
                const totalsColumns = { amount: 0, daysAvg: 0, qty: 0 }
                this.items.forEach(i => {
                    totalsColumns.amount += i.amount
                    totalsColumns.daysAvg += parseFloat(i.daysAvg) || 0
                    totalsColumns.qty += i.qty
                })
                totalsColumns.amountLabel = currency(totalsColumns.amount)
                totalsColumns.daysAvg = Number(totalsColumns.daysAvg/(this.items.length || 1)).toFixed(2)
                return totalsColumns
            },
        },

        data() {
            return {
                viewAll: false,
                tableName: 'open-services',
                isDetailsModalActive: false,
                isTableVisible: true,
                selectedRow: {},
                table: {
                    bordered: false,
                    checkable: true,
                    defaultSort: ['amountLabel', 'desc'],
                    mobileCards: true,
                    narrowed: false,
                    paginated: true,
                    perPage: 10,
                    perPageOptions: [5, 10, 15, 25, 50],
                    striped: true,
                },
                items: []
            }
        },

        methods: {

            customSort(itemA, itemB, isAsc) {
                let a = parseFloat(itemA.amount), b = parseFloat(itemB.amount)
                return isNaN(a) && !isNaN(b) ? 1 : isNaN(b) && !isNaN(a) ? -1 : isAsc ? (a > b ? 1 : a === b ? 0 : -1) : ( b > a ? 1 : a === b ? 0 : -1 )
            },

            customSortDaysAvg(itemA, itemB, isAsc) {
                let a = parseFloat(itemA.daysAvg), b = parseFloat(itemB.daysAvg)
                return isNaN(a) && !isNaN(b) ? 1 : isNaN(b) && !isNaN(a) ? -1 : isAsc ? (a > b ? 1 : a === b ? 0 : -1) : ( b > a ? 1 : a === b ? 0 : -1 )
            },

            openDetailsModal(row) {
                this.selectedRow = {
                    filters: this.filters,
                    service_id: row.id, 
                    service_title: row.title,
                }
                this.isDetailsModalActive = true
            },

            processRawData(rawData) {
                if(!rawData){
                    return []
                }
                const currency = this.$filters.currency
                const dataObject = {}
                const rd = [...rawData ]
                rd.forEach((i,idx) => {
                    const amount = isNaN(i.amount) ? 0 : parseFloat(i.amount)
                    const amountLabel = currency(amount)
                    const qty = isNaN(i.qty) ? 0 : parseInt(i.qty)
                    const daysAvg = parseFloat(i.daysAvg) || 0
                    if( !dataObject[getGroupingKey(i)] ) {
                        dataObject[getGroupingKey(i)] = { id: i.service_id, amount, amountLabel, daysAvg, qty, title: i.service_title }
                    } else {
                        dataObject[getGroupingKey(i)].amount += amount
                        dataObject[getGroupingKey(i)].amountLabel = currency(dataObject[getGroupingKey(i)].amount)
                        dataObject[getGroupingKey(i)].qty += qty
                    }
                    dataObject[getGroupingKey(i)].daysAvg = Number(dataObject[getGroupingKey(i)].daysAvg).toFixed(2)
                    dataObject[getGroupingKey(i)].items = dataObject[getGroupingKey(i)].items || []
                    dataObject[getGroupingKey(i)].items.push({...i, amountLabel})
                })
                this.items = Object.keys(dataObject).map(k => dataObject[k])
            },
        },

        mounted() {
            this.processRawData(this.data)
        },

        props: {
            data: {
                type: Array,
                default () {
                    return []
                }
            },
            loading: {
                default: false,
                type: Boolean,
            },
            filters: {
                type: Object,
                default () {
                    return {}
                }
            },
        },

        watch: {
            appIsHydrated() {
                this.isTableVisible = true
            },
            data: {
                deep: true,
                handler() {
                    this.processRawData(this.data)
                }
            },
        },
    }
</script>

<style>
.open-services-table {
  width: fit-content; }
.open-services-table .table-wrapper {
  min-height: auto;
  overflow-x: auto; }
.open-services-table .table-wrapper table {
  display: block;
  white-space: nowrap; }
.open-services-table .table-wrapper table th:not(:first-child) > .th-wrap {
  justify-content: center; }
.open-services-table .table-wrapper table tbody > tr > td:not(:first-child) {
  text-align: center; }
.open-services-table .table-wrapper table tfoot tr th:not(:first-child) {
  text-align: center; }

</style>